var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getExtendedUserRequest } from "../../api/api";
import { WPQTPageHeader } from "../../components/common/Header/Header";
import { SET_FULL_PAGE_LOADING } from "../../constants";
import { LoadingContext } from "../../providers/LoadingContextProvider";
import { convertExtendedUserFromServer } from "../../utils/user";
import { Page } from "../Page/Page";
import { UserControls } from "./components/UserControls/UserControls";
import { UserDetails } from "./components/UserDetails/UserDetails";
function UserPage({ userId }) {
    const { loadingDispatch } = useContext(LoadingContext);
    const [userData, setUserData] = useState(null);
    useEffect(() => {
        const getUserData = () => __awaiter(this, void 0, void 0, function* () {
            try {
                loadingDispatch({ type: SET_FULL_PAGE_LOADING, payload: true });
                const response = yield getExtendedUserRequest(userId);
                setUserData(convertExtendedUserFromServer(response.data));
            }
            catch (error) {
                console.error(error);
                toast.error(__("Failed to get user data. Please try again", "quicktasker"));
            }
            finally {
                loadingDispatch({ type: SET_FULL_PAGE_LOADING, payload: false });
            }
        });
        getUserData();
    }, []);
    const onChangeStatus = (status) => __awaiter(this, void 0, void 0, function* () {
        setUserData((prevData) => {
            if (prevData) {
                return Object.assign(Object.assign({}, prevData), { is_active: status });
            }
            return prevData;
        });
    });
    const onChangeSetUpStatus = (status) => __awaiter(this, void 0, void 0, function* () {
        setUserData((prevData) => {
            if (prevData) {
                return Object.assign(Object.assign({}, prevData), { setup_completed: status });
            }
            return prevData;
        });
    });
    const onChangePasswordStatus = (status) => __awaiter(this, void 0, void 0, function* () {
        setUserData((prevData) => {
            if (prevData) {
                return Object.assign(Object.assign({}, prevData), { has_password: status });
            }
            return prevData;
        });
    });
    return (_jsx(Page, { children: userData && (_jsxs(_Fragment, { children: [_jsx(WPQTPageHeader, { description: __("User details", "quicktasker"), children: userData.name }), _jsx(UserDetails, { data: userData }), _jsx(UserControls, { data: userData, changeStatus: onChangeStatus, changeSetUpStatus: onChangeSetUpStatus, changePasswordStatus: onChangePasswordStatus })] })) }));
}
export { UserPage };
